// Shared customer-facing labels used across features. See
// docs/features/2026.10.09-static-string-consolidation/decisions/2026.10.09-001-static-copy-data-objects.md
export const commonContent = {
  // Actions
  applyLabel: 'Apply',
  backLabel: 'Back',
  cancelLabel: 'Cancel',
  closeLabel: 'Close',
  continueLabel: 'Continue',
  doneLabel: 'Done',
  editLabel: 'Edit',
  saveLabel: 'Save',
  showMoreLabel: 'Show More',
  showLessLabel: 'Show Less',

  // Package CTAs
  selectPackageLabel: 'Select Package',
  selectedPackageLabel: 'Selected',
  addToCartLabel: 'Add to Cart',
  removeFromCartLabel: 'Remove from Cart',
  noThanksLabel: 'No Thanks',

  // Navigation
  seeGalleryLabel: 'See Gallery',

  // States
  loadingLabel: 'Loading...'
}
